import axios from "axios";
import { IconButton } from "@mui/material";
import EditIcon from "@material-ui/icons/Edit";
import LoanIDHistoryModal from "../modals/LoanIDHistoryModal";
import useDialog from "../../hooks/useDialog"; // Import the hook

export default function LoanID({ isBankHead, application }) {
  const { promptInput, showSnackbar } = useDialog(); // Use the hook

  const handleEditClick = async () => {
    const newID = await promptInput({
      title: "სესხის ID-ს ცვლილება",
      message: "სესხის ID-ს ცვლილება მოხდება მომენტალურად. ცვლილება შეინახება სესხის ისტორიაში.",
      label: "ახალი სესხის ID",
      initialValue: application?.loan_information?.loan_id,
    });

    if (newID !== null && newID.trim() !== "") {
      try {
        const res = await axios.post("/bank/application/change_id", {
          loanID: application?._id,
          component: window.location.pathname.split("/")[1],
          newID: newID,
        });
        showSnackbar(res.data.message, "success");
        setTimeout(() => window.location.reload(), 1000); // Reload after showing message
      } catch (err) {
        const errorMessage = err.response?.data?.message || "დაფიქსირდა შეცდომა";
        showSnackbar(errorMessage, "error");
      }
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
      {isBankHead && application?.approved && (
        <IconButton style={{ padding: "0", margin: "0 4px 0 0" }} color="primary" aria-label="edit" onClick={handleEditClick}>
          <EditIcon fontSize="small" />
        </IconButton>
      )}
      <p style={{ margin: 0, fontWeight: "bold" }}>{application?.loan_information?.loan_id}</p>
      {application?.loan_information?.loan_id_history?.length > 0 && <LoanIDHistoryModal history={application?.loan_information?.loan_id_history} />}
    </div>
  );
}
